import originalIsomorphicFetch from 'isomorphic-fetch';


export function createIsomorphicFetch(
  responseFactory = null, fetcher = originalIsomorphicFetch) {
  return function fetch(url, opts = {}) {
    const finalFactory = responseFactory || ((response) => response);
    const defaultOptions = {
      method: 'GET',
      headers: undefined
    };
    const options = {
      ...defaultOptions,
      ...opts
    };

    return new Promise(
      (resolve, reject) => {
        fetcher(url, options)
          .then(
            (response) => {
              resolve(finalFactory(response));
            }
          ).catch(
            (response) => {
              reject(finalFactory(response));
            }
          );
      }
    );
  };
}

export async function isomorphicFetch(url, opts = {}) {
  return createIsomorphicFetch(null, originalIsomorphicFetch)(url, opts);
}
